import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Events } from '../../pages/Events';

const eventsSearchSchema = z.object({
  tab: z.enum(['upcoming', 'going', 'past']).optional().default('upcoming'),
});

export const Route = createFileRoute('/_authenticated/events/')({
  component: Events,
  validateSearch: eventsSearchSchema,
});
